import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Configurator from "@/pages/Configurator";
import Collection from "@/pages/Collection";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Checkout from "@/pages/Checkout";
import AdminSaved from "@/pages/AdminSaved";

// Ensures every route change starts at the top of the page, unless the
// URL carries a #hash (e.g. /about#geschichte), in which case we scroll
// smoothly to that section instead. Runs on every pathname/hash change.
const ScrollManager = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // Wait a tick so the target page has rendered before we measure it.
      const raf = requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo(0, 0);
        }
      });
      return () => cancelAnimationFrame(raf);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

const HAS_BACKEND = Boolean(process.env.REACT_APP_BACKEND_URL);

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <ScrollManager />
          <Navbar />
          <CartDrawer />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/configurator" element={<Configurator />} />
            <Route path="/collection" element={<Collection />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/checkout" element={HAS_BACKEND ? <Checkout /> : (
              <main className="min-h-screen pt-40 pb-32 bg-[#170F09] text-white">
                <div className="max-w-3xl mx-auto px-6 text-center">
                  <div className="kicker mb-5">SOMMET UHRENWERKE · VORSCHAU</div>
                  <h1 className="section-heading text-4xl md:text-5xl mb-7">Online-Bestellungen folgen</h1>
                  <p className="text-white/70 leading-relaxed mb-8">Diese Website wird derzeit getestet. Bestellungen und Zahlungen sind noch nicht aktiv. Für Fragen kontaktieren Sie uns direkt.</p>
                  <a className="btn-champagne" href="mailto:sommetuhrenwerke@gmail.com">Kontakt per E-Mail</a>
                </div>
              </main>
            )} />
            <Route path="/admin/saved" element={HAS_BACKEND ? <AdminSaved /> : <Navigate to="/" replace />} />
          </Routes>
          <Footer />
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#21160B",
                border: "1px solid rgba(201,163,107,0.4)",
                color: "#fff",
              },
            }}
          />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
